<template>
<div class="AdminPanelNews">
  <div class="page" v-if="$store.getters['auth/isAllowed']('can_view_admin_panel')">
    <BackBtn />
    <BreadCrumbs :items="breadcrumbs" />
    <div class=" d-flex align-center pb-4 mb-4">
      <h1 class="font-lg">Управление новостями сервиса</h1>
    </div>

    <div>
      <v-btn
        large
        class="AdminPanelNews__btn mb-4"
        color="white"
        outlined
        @click="openCreateModal"
      >
        Добавить модальное окно
      </v-btn>
    </div>
    <TableNews
      @deleteNews="deleteItemNews"
      @editItem="editItem"
      @draftedNews="attemptPartiallyUpdateNews"
      @publishedNews="attemptPartiallyUpdateNews"
    />
  </div>
  <ModalCreateNews
    :open-modal="showCreateModal"
    :updateItem="currentNews"
    @closeModal="closeCreateModal"
    @createNews="attemptCreateNews"
    @updateNews="attemptUpdateNews"
  />
  <ModalWithAction
    title="Модальное окно добавлено"
    image-slot
    :show-modal="showSuccessModal"
    :cancel-button="false"
    @closeModal="showSuccessModal = false"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          class="text-center"
          src="@/assets/images/adminPanel/success.webp"
          max-width="86px"
        />
      </div>
    </template>
  </ModalWithAction>
  <ModalWithAction
    title="Модальное окно не добавлено"
    image-slot
    :show-modal="showFailedModal"
    :cancel-button="false"
    @closeModal="showFailedModal = false"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          class="text-center"
          src="@/assets/images/adminPanel/failed.webp"
          max-width="86px"
        />
      </div>
    </template>
  </ModalWithAction>
  <ModalWithAction
    title="Модальное окно успешно отредактировано"
    image-slot
    :show-modal="showUpdateModal"
    :cancel-button="false"
    @closeModal="showUpdateModal = false"
  >
    <template v-slot:image>
      <div class="d-flex justify-center">
        <v-img
          class="text-center"
          src="@/assets/images/adminPanel/success.webp"
          max-width="86px"
        />
      </div>
    </template>
  </ModalWithAction>
</div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex';
import ModalWithAction from '@/components/admin-panel/Modal/ModalWithAction.vue';
import TableNews from '@/components/admin-panel/TableNews.vue';
import ModalCreateNews from './Modal/ModalCreateNews.vue';

/**
 * Компонент: AdminPanelNews
 * Описание:
 */
export default {
  name: 'AdminPanelNews',

  components: {
    TableNews,
    ModalWithAction,
    ModalCreateNews,
  },

  props: {},

  data() {
    const showCreateModal = false;
    const showSuccessModal = false;
    const showFailedModal = false;
    const showUpdateModal = false;
    return {
      showCreateModal,
      showSuccessModal,
      showFailedModal,
      showUpdateModal,
    };
  },

  computed: {
    ...mapGetters({
      bannerLinks: 'users/admins/hasBannerLinks',
      user: 'auth/user',
      stepCreatingNews: 'news/modals/currentStepCreating',
      currentNews: 'news/modals/currentNews',
    }),
    breadcrumbs() {
      return [
        { title: 'Админка', url: '/admin-panel' },
        { title: 'Управление новостями сервиса', url: '' },
      ];
    },

  },

  watch: {},

  created() {
  },

  async mounted() {
    await this.fetchAllNews();
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      fetchAllNews: 'news/modals/fetchAllNews',
      createNews: 'news/modals/createNews',
      updateNews: 'news/modals/updateNews',
      createNewsImage: 'news/modals/createNewsImage',
      deleteNews: 'news/modals/deleteNews',
      fetchDetailNews: 'news/modals/fetchDetailNews',
      partiallyUpdateNews: 'news/modals/partiallyUpdateNews',
    }),
    ...mapMutations({
      SET_STEP_CREATING: 'news/modals/SET_STEP_CREATING',
      SET_DETAIL_NEWS: 'news/modals/SET_DETAIL_NEWS',
    }),
    async attemptCreateNews(data) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      try {
        // stage 1 - main
        const newsPayload = {
          title: data.fieldName,
          text: data.fieldBody,
        };
        const createdNews = await this.createNews(newsPayload);
        if (!createdNews.success || !createdNews.data.id) {
          throw new Error('Не удалось создать новость');
        }
        // stage 2 - upload image
        if (data.fieldImage) {
          const formData = new FormData();
          formData.set('file', data.fieldImage);
          const imagePayload = {
            id: createdNews.data.id,
            formData
          };
          const uploadImage = await this.createNewsImage(imagePayload);
          if (uploadImage.success && this.stepCreatingNews === 2) {
            this.showCreateModal = false;
            this.showSuccessModal = true;
            await this.fetchAllNews();
          } else if (!uploadImage.success) {
              this.showFailedModal = true;
              this.$toast.error(uploadImage.data.data.detail, '', { position: 'topRight' });
            }
        }
      } catch (error) {
        this.showFailedModal = true;
        this.$toast.error(error, '', { position: 'topRight' });
      } finally {
        this.showCreateModal = false;
      }
    },
    async attemptPartiallyUpdateNews(data, status) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      try {
        // stage 1 - main
        const newsPayload = {
          id: data.id,
          is_active: status
        };
        const createdNews = await this.partiallyUpdateNews(newsPayload);
        if (!createdNews.success || !createdNews.data.id) {
          throw new Error('Не удалось обновить новость');
        } else {
          this.showCreateModal = false;
          this.showUpdateModal = true;
          await this.fetchAllNews();
        }
      } catch (error) {
        this.showFailedModal = true;
        this.$toast.error(error, '', { position: 'topRight' });
      } finally {
        this.showCreateModal = false;
      }
    },
    async attemptUpdateNews(data, status) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      console.log(data);
      console.log(status);
      try {
        // stage 1 - main
        const newsPayload = {
          id: data.id,
          title: data.fieldName,
          text: data.fieldBody,
        };
        const createdNews = await this.updateNews(newsPayload);
        if (!createdNews.success || !createdNews.data.id) {
          throw new Error('Не удалось обновить новость');
        }
        // stage 2 - upload image
        if (data.fieldImage) {
          const formData = new FormData();
          formData.set('file', data.fieldImage);
          const imagePayload = {
            id: createdNews.data.id,
            formData
          };
          const uploadImage = await this.createNewsImage(imagePayload);
          if (uploadImage.success && this.stepCreatingNews === 2) {
            this.showCreateModal = false;
            this.showSuccessModal = true;
            await this.fetchAllNews();
          } else if (!uploadImage.success) {
            this.showFailedModal = true;
            this.$toast.error(uploadImage.data.data.detail, '', { position: 'topRight' });
          }
        }
      } catch (error) {
        this.showFailedModal = true;
        this.$toast.error(error, '', { position: 'topRight' });
      } finally {
        this.showCreateModal = false;
      }
    },
    closeCreateModal() {
      this.showCreateModal = false;
      this.SET_DETAIL_NEWS({});
    },
    openCreateModal() {
      this.showCreateModal = true;
    },
    async deleteItemNews(data) {
      if (!this.$store.getters['auth/isAllowed']('can_view_admin_panel')) return;
      if (data.id) {
        const res = await this.deleteNews(data);
        if (!res.success) {
          this.$toast.error(res.data.data.detail, '', { position: 'topRight' });
        }
      } else {
        this.$toast.error('ID новости нет!', '', { position: 'topRight' });
      }
      await this.fetchAllNews();
    },
    async editItem(news) {
      const payload = {
        id: news.id,
      };
      const detailNews = await this.fetchDetailNews(payload);
      if (!detailNews.success) {
        this.$toast.error(detailNews.data, '', { position: 'topRight' });
      } else {
        this.showCreateModal = true;
      }
    }

  },
};
</script>

<style scoped lang="scss">
.AdminPanelNews {
  /* Стили компонента */
  & .AdminPanelNews__btn{
    background: var(--color-blue-500);
    border-radius: 6px;
    height: 100%;
    font-size: 16px;
    padding: 10px 16px;
    margin-left: 8px;
    ::v-deep span{
      line-height: 24px;
    }
  }
}
</style>
